import {combineReducers} from 'redux'
import NotificationsReducer from 'reducers/Notifications'
import AuthenticationReducers from 'reducers/Authentication'
import UserReducers from 'reducers/User'
import SectorReducers from 'reducers/Sector'
import LocationReducers from 'reducers/Location'
import GlobalReducers from 'reducers/Global'
import VariableReducers from './Variable'
/**
 * Todos os reducers devem ser adicionados aqui
 */
const RootReducers = combineReducers({    
    notificationsReducer : NotificationsReducer,    
    authenticationReducers : AuthenticationReducers,
    userReducers : UserReducers,
    sectorReducers : SectorReducers,
    locationReducers : LocationReducers,
    globalReducers : GlobalReducers,
    variableReducers : VariableReducers
})
/* Exportando tipo dinamico do objeto com todos os Reducers */
export type RootState = ReturnType<typeof RootReducers>
export default RootReducers
